import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";

const Blurb = ( {blurb} ) => {


    return ( 
        <div className= 'blurb'>
       
        
           <h3> {blurb}</h3>
        
           
        {/* <h3 style={{fontWeight:'300'}}><ReadMoreReact text={blurb}
                min={200}
                ideal={250}
                max={1000}
                readMoreText={<font style={{color: 'var(--accent)', cursor: 'pointer', fontWeight: '600'}}>Read More</font>}/></h3>*/}
        </div> 
     );
}
 
export default Blurb;